import { AxiosPromise } from 'axios';
import { AvailableNumber } from '../../types/AvailableNumber';
import { libApiInstance } from '../axios';
import { AvailableNumbersRequest } from './types/AvailableNumbersRequest';

export function requestAvailableNumbers(
    data: AvailableNumbersRequest,
    signal?: AbortSignal,
): AxiosPromise<AvailableNumber[]> {
    return libApiInstance.post('/users/twilio/getNumbers', data, {
        signal,
    });
}

export function requestCanChangeSicNumber(signal?: AbortSignal): AxiosPromise<boolean> {
    return libApiInstance.get('/users/twilio/canChangeNumber', {
        signal,
    });
}

export function requestChangeSicNumber(
    newNumber: string,
    signal?: AbortSignal,
): AxiosPromise<void> {
    return libApiInstance.post(`/users/twilio/changeNumber`, newNumber, {
        signal,
    });
}
